import { createRouter, createWebHashHistory } from "vue-router";
import { beforeEachGuards } from "./guards";
// import routeList from './routes.js'
const routes = [
  {
    path: "/",
    name: "HomePage",
    hideInMenu: true,
    title: "首页",
    isShow: true,
    component: () => import("@/pages/homePage/index.vue"),
  },
  {
    path: "/race-info",
    name: "RaceInfo",
    hideInMenu: true,
    title: "赛事说明",
    isShow: true,
    component: () => import("@/pages/race-info.vue"),
  },
  {
    path: "/race-news",
    name: "RaceNews",
    hideInMenu: true,
    title: "赛事资讯",
    isShow: true,
    component: () => import("@/pages/race-news.vue"),
  },
  {
    path: "/news-detail",
    name: "NewsDetail",
    hideInMenu: true,
    title: "文字详情",
    isShow: true,
    component: () => import("@/pages/news-detail.vue"),
  },
  {
    path: "/race-video",
    name: "RaceVideo",
    hideInMenu: true,
    title: "赛事视频",
    isShow: true,
    component: () => import("@/pages/race-video.vue"),
  },
  {
    path: "/race-honors",
    name: "RaceHonors",
    hideInMenu: true,
    title: "赛事荣誉榜",
    isShow: true,
    component: () => import("@/pages/race-honors.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// // 全局前置守卫
beforeEachGuards.forEach((beforeEachGuard) => {
  router.beforeEach(beforeEachGuard);
});

export default router;
